import { z } from "zod";
import { Signature } from "../enums/Signature";
import { dateSchema } from "../utils/DateSchema";
import { idSchema } from "../utils/IdSchema";
import { nameSchema } from "../utils/NameSchema";
import { requiredStringSchema } from "../utils/RequiredStringSchema";
import { ExcessLiabilityPolicySchema } from "./ExcessLiabilityPolicy";
import { GeneralLiabilityPolicySchema } from "./GeneralLiabilityPolicy";
import { ProjectSchema } from "./Project";
import { SourceSchema } from "./Source";

export const RenewalSchema = z.object({
  id: idSchema(),
  name: requiredStringSchema().max(250),
  enrollees: z
    .array(
      z.object({
        enrolleeId: idSchema(),
        enrolleeName: requiredStringSchema().max(250),
      }),
    )
    .optional(),
  certificates: z
    .array(
      z.object({
        certificateId: idSchema(),
        certificateName: requiredStringSchema().max(250).optional(),
        enrolleeId: idSchema(),
      }),
    )
    .optional(),
  project: ProjectSchema.omit({ source: true }),
  source: SourceSchema,
  effectiveDate: dateSchema(),
  expirationDate: dateSchema(),
  authorizedRepresentative: nameSchema().optional(),
  descriptionOfOperations: z.string().max(2000),
  policies: z.object({
    generalLiability: GeneralLiabilityPolicySchema.optional(),
    excessLiabilities: z.array(ExcessLiabilityPolicySchema),
  }),
  signature: Signature.optional(),
  updatedDate: dateSchema().optional(),
  createdDate: dateSchema().optional(),
});

export type Renewal = z.infer<typeof RenewalSchema>;
